import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';

export type FormInputProps = {
  control: Control<any>;
  name: string;
  readonly?: boolean;
  disableRequiredErrorIndication?: boolean;
} & Omit<TextFieldProps, 'name'>;
export const FormInput = ({
  control,
  name,
  readonly,
  disableRequiredErrorIndication,
  ...textProps
}: FormInputProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, value, ...fieldRest }, fieldState: { error } }) => {
        const isRequiredErrorType = error?.message === 'required';
        const shouldIndicateError = !!error && !(isRequiredErrorType && disableRequiredErrorIndication);
        return (
          <TextField
            {...textProps}
            {...fieldRest}
            value={value ?? ''}
            inputRef={ref}
            error={shouldIndicateError}
            helperText={
              shouldIndicateError && error?.message ? resolveErrorMessage(error.message) : textProps.helperText
            }
            fullWidth
            variant={readonly ? 'standard' : textProps.variant}
            InputProps={{
              ...textProps.InputProps,
              readOnly: readonly ?? textProps.InputProps?.readOnly,
              disableUnderline:
                textProps.variant !== 'outlined' ? (readonly ?? textProps.InputProps?.readOnly) : undefined,
            }}
          />
        );
      }}
    />
  );
};
